import React, { useEffect, useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import NotificationManager from "react-notifications/lib/NotificationManager";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { fileDocumentService } from "../../services/fileDocumentTemplateService";
import ApiUrls from "../../helper/api-urls";
import ApiHelper from "../../helper/api-helper";
import Loader from "../../control-components/loader/loader";
import InputKendoRct from "../../control-components/input/input";

const UpdateTemplate = ({ onClose, documentTemplateId, regionId, editSelectedData, getAllDefaultDocumentTemplates }) => {
    const DocumentTemplate = {
        id: editSelectedData?.templateTypeId,
        name: editSelectedData?.templateTypeName
    }

    const [loading, setLoading] = useState(false);
    const [templateType, setTemplateType] = useState([])
    const [fields, setField] = useState({
        templateTypeId: DocumentTemplate,
        templateName: editSelectedData?.templateName,
        htmlFileName: editSelectedData?.htmlFileName
    })


    useEffect(() => { getTemplateType() }, []);

    const getTemplateType = () => {
        setLoading(true);
        ApiHelper.getRequest(ApiUrls.DOCUMENT_TEMPLATE_TYPE + 1)
            .then((result) => {
                setLoading(false);

                setTemplateType(result.resultData);
            })
            .catch((error) => {
                setLoading(false);
                NotificationManager.error(error.message);
            });
    };

    const editTemplate = async () => {
        setLoading(true);
        await fileDocumentService
            .updateTemplate(fields, documentTemplateId, regionId)
            .then((result) => {
                setLoading(false);
                NotificationManager.success("Update Document Template successfully");
                getAllDefaultDocumentTemplates()
                onClose({ updated: true });

            })
            .catch((error) => {
                setLoading(false);
                NotificationManager.error(error);
            });
    };

    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        setField({
            ...fields,
            [name]: value
        })
    }
    const handleSubmit = () => {
        editTemplate();
    };

    return (
        <div>
            {loading == true && <Loader />}
            <Dialog
                onClose={onClose}
                title={"Edit Document Template"}
                className="small-dailog"
            >
                <div className="edit-client-popup">
                    <div className="popup-modal slibling-data">
                        <div className="row">
                            <div>
                                <DropDownKendoRct
                                    filterable={true}
                                    label="Template Type"
                                    onChange={handleChange}
                                    data={templateType}
                                    value={fields.templateTypeId}
                                    textField="name"
                                    name="templateTypeId"
                                    dataItemKey="id"
                                    suggest={true}
                                />
                            </div>
                            <div className="mt-2">
                                <InputKendoRct
                                    value={fields.templateName}
                                    onChange={handleChange}
                                    name="templateName"
                                    label="Template Name"
                                    className="form-control"
                                    placeholder="Template name"
                                />
                            </div>
                            <div className="mt-2">
                                <InputKendoRct
                                    value={fields.htmlFileName}
                                    onChange={handleChange}
                                    name="htmlFileName"
                                    label="Html File Name"
                                    className="form-control"
                                    placeholder="Template name"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="border-bottom-line"></div>
                <div className="d-flex my-3">
                    <div className="right-sde">
                        <button className="green-btn btn-primary mx-3" onClick={handleSubmit}>
                            Update
                        </button>
                    </div>
                    <div className="right-sde-grey">
                        <button
                            className="btn grey-secondary text-white "
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
export default UpdateTemplate;
